import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import './App.css';
import Home from './pages/Home';
import Join from './pages/Join';
import Room from './pages/Room';
import Logo from './components/Logo';
import RulesWidget from './components/RulesWidget';

function App() {
  return (
    <Router>
      <div className="app-shell">
        <header className="app-header">
          <div className="app-header-inner">
            <Link to="/" className="app-brand" aria-label="Songle home">
              <Logo size="small" />
            </Link>
            <nav className="app-nav" aria-label="Site">
              <RulesWidget />
            </nav>
          </div>
        </header>

        <Toaster
          position="top-center"
          containerStyle={{ top: 84 }}
          toastOptions={{
            duration: 4500,
            style: {
              background: 'rgba(21, 18, 42, 0.96)',
              color: '#f3f2fa',
              border: '1px solid rgba(255, 255, 255, 0.12)',
              borderRadius: '14px',
              boxShadow: '0 20px 50px -20px rgba(0, 0, 0, 0.8)',
              padding: '12px 16px',
              fontWeight: 500,
              maxWidth: '520px',
              backdropFilter: 'blur(12px)',
            },
            success: {
              iconTheme: { primary: '#34d399', secondary: '#0e0c1a' },
            },
            error: {
              iconTheme: { primary: '#fb7185', secondary: '#0e0c1a' },
            },
          }}
        />

        <div className="app">
          <main className="app-main">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/join" element={<Join />} />
              <Route path="/join/:roomId" element={<Join />} />
              <Route path="/room/:roomId" element={<Room />} />
            </Routes>
          </main>

          <footer className="app-footer">
            <span>Songle · a multiplayer song guessing game</span>
            <a href="mailto:contact@playpartygames.io">contact@playpartygames.io</a>
          </footer>
        </div>
      </div>
    </Router>
  );
}

export default App;
